var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"not-available-yet"}},[_c('section',[_c('h1',[_vm._v("De WachtrijBooster is op dit moment nog niet in gebruik")])])])}]

export { render, staticRenderFns }